<template>
  <div class="card mb-2">
    <div class="card-body bg-secondary pt-2 pb-0 pl-1 pr-2">
      <b-form class="search-form" @submit.prevent="onSearch">
        <div class="d-flex">
          <div class="row align-items-center">
            <div class="input-wrapper">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="filename"/>
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="status" type="select2" :items="statuses" value-field="value"
                            :label="false" :options="{placeholder: $t('Status')}" display-field="${item.key}" />
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="sent_date" type="daterangepicker" :label="false"
                            :placeholder="$t('Sent Date')" class="sentDateRangePicker"/>
            </div>
          </div>
          <div class="search-btn-wrapper">
            <b-button variant="primary" @click.prevent="onResetClick">
              <font-awesome-icon icon="undo" class="icon"/>
              {{ $t('Reset') }}
            </b-button>
            <b-button type="submit" variant="primary" class="ml-2">
              <font-awesome-icon icon="search" class="icon"/>
              {{ $t('Search') }}
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
  import InputWidget from "../../core/components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";
  import i18n from "@/shared/i18n";

  const {mapState, mapActions} = createNamespacedHelpers('contracts');

  export default {
    name: "ContractSearch",
    components: {InputWidget},
    computed: {
      ...mapState({
        searchModel: state => state.tableData[state.tableSource].searchModel,
      }),
    },
    data() {
      return {
        statuses: [
          {value: 'draft', key: i18n.t('Draft'),},
          {value: 'sent', key: i18n.t('Sent'),},
          {value: 'signed', key: i18n.t('Signed'),},
        ]
      }
    },
    methods: {
      ...mapActions(['getTableData', 'updateSearchModel', 'resetTable', 'resetTableDataPaginationPage']),
      async onSearch() {
        await this.updateSearchModel(this.searchModel);
        this.resetTableDataPaginationPage();
        this.getTableData();
      },
      onResetClick() {
        this.searchModel.sent_date = null
        this.searchModel.sent_date_date_range = {startDate: null, endDate: null};
        this.$nextTick(() => {
          this.resetTable();
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .sentDateRangePicker /deep/ .form-group {
    margin-bottom: 0;
  }
</style>
